import { isPossiblePhoneNumber, isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input'

/** E.164-style "+{digits}" for API requests */
export function normalizePhone(phone) {
  if (phone == null || phone === '') return ''
  // eslint-disable-next-line
  const compact = String(phone)
    .trim()
    .replace(/[\s\-().]/g, '')
  if (!compact) return ''
  // eslint-disable-next-line
  if (compact.startsWith('+')) {
    const digits = compact.slice(1).replace(/\D/g, '')
    return digits ? `+${digits}` : ''
  }
  const digits = compact.replace(/\D/g, '')
  return digits ? `+${digits}` : ''
}

/**
 * Booking phone check: strict libphonenumber validity, with Oman (+968) fallback.
 * Many real OM numbers are "possible" but not "valid" (e.g. +968 34682317).
 */
export function isValidBookingPhone(phone) {
  // eslint-disable-next-line
  const value = phone != null ? String(phone).trim() : ''
  if (!value) return false
  if (isValidPhoneNumber(value)) return true

  if (!isPossiblePhoneNumber(value)) return false

  try {
    const parsed = parsePhoneNumber(value)
    if (parsed?.country === 'OM') {
      const nationalLen = String(parsed.nationalNumber || '').length
      return nationalLen >= 8
    }
  } catch {
    return false
  }

  return false
}
